module.exports = __webpack_public_path__ + "img/map1.704f73fa.png";